import { defineMessage } from "@lingui/macro";

export const READONLY_GRID_FIELDS = [
  "ProfilePicture",
  "FirstName",
  "LastName",
  "NickName",
  "Email",
  "Groups",
  "Manager",
  "Status",
  "_created_by",
  "_created_at",
  "TFAEnrollment",
  "ExternalId",
  "LastLoggedInAt",
  "_programmatic_access",
  "_last_access"
];

export const PORTAL_GRID_FIELDS = [
  "ProfilePicture",
  "FirstName",
  "LastName",
  "Email",
  "Status",
  "_created_by",
  "_created_at",
  "LastLoggedInAt",
  "_last_access"
];

export const EXCLUDE_READONLY_GRID_FIELDS = ["Name", "AboutMe"];

export const PORTAL_SHOW_HIDE_EXTRA_FIELDS = [
  {
    Id: "_last_access",
    Width: 402,
    Name: "Last access",
    Type: "JSON",
    IsSystemField: false,
    IsProtected: true,
    IsHidden: false,
    Widget: null,
    Permission: "ReadOnly",
    Required: false,
    ModelId: "User"
  }
];

export const SHOW_HIDE_EXTRA_FIELDS = [
  {
    Id: "_last_access",
    Width: 402,
    Name: "Last access",
    Type: "JSON",
    IsSystemField: false,
    IsProtected: true,
    IsHidden: false,
    Widget: null,
    Permission: "ReadOnly",
    Required: false,
    ModelId: "User"
  },
  {
    Id: "_programmatic_access",
    Width: 400,
    Name: "Programmatic access",
    Type: "JSON",
    IsSystemField: false,
    IsProtected: true,
    IsHidden: false,
    Widget: null,
    Permission: "ReadOnly",
    Required: false,
    ModelId: "User"
  }
];

export const SORT_OPTIONS = {
  ascending: "ASC",
  descending: "DESC"
};

export const HEADER_OPTIONS = {
  HIDE: "Hide"
};

export const HEADER_MENU_LIST = [
  {
    content: defineMessage`Sort in ascending order`,
    key: SORT_OPTIONS.ascending
  },
  {
    content: defineMessage`Sort in descending order`,
    key: SORT_OPTIONS.descending
  },
  { content: defineMessage`Hide column`, key: HEADER_OPTIONS.HIDE }
];

export const MEMBER_DASHBOARD_STATUS_IDS = {
  ACTIVE: "ACTIVE",
  REQUESTED: "REQUESTED",
  INVITED: "INVITED",
  INACTIVE: "INACTIVE"
};

export const MEMBER_DASHBOARD_STATUS = [
  {
    id: MEMBER_DASHBOARD_STATUS_IDS.ACTIVE,
    key: "Active",
    title: defineMessage`Active users`,
    count: 0,
    background: "var(--kf-color-secondary-one-100)",
    activeBorderColor: "var(--kf-color-secondary-one-500)",
    borderColor: "var(--kf-color-secondary-one-200)"
  },
  {
    id: MEMBER_DASHBOARD_STATUS_IDS.REQUESTED,
    key: "Requested Access",
    title: defineMessage`Join requests`,
    count: 0,
    background: "var(--kf-color-secondary-ten-100)",
    activeBorderColor: "var(--kf-color-secondary-ten-500)",
    borderColor: "var(--kf-color-secondary-ten-200)"
  },
  {
    id: MEMBER_DASHBOARD_STATUS_IDS.INVITED,
    key: "Invited",
    title: defineMessage`Open invites`,
    count: 0,
    background: "var(--kf-color-secondary-six-100)",
    activeBorderColor: "var(--kf-color-secondary-six-500)",
    borderColor: "var(--kf-color-secondary-six-200)"
  },
  {
    id: MEMBER_DASHBOARD_STATUS_IDS.INACTIVE,
    key: "InActive",
    title: defineMessage`Inactive users`,
    count: 0,
    background: "var(--kf-color-gray-100)",
    activeBorderColor: "var(--kf-color-gray-400)",
    borderColor: "var(--kf-color-gray-200)"
  }
];

export const TWO_FACTOR_OPTIONS = {
  Recommended: { value: "Recommended", label: defineMessage`Recommended` },
  Mandatory: { value: "Mandatory", label: defineMessage`Mandatory` },
  Disable: { value: "Disable", label: defineMessage`Disable` },
  SecretCodeMaxLength: 6
};

export const TWO_FACTOR_DETAILS = [
  {
    value: TWO_FACTOR_OPTIONS.Recommended.value,
    description: defineMessage`Allow users to sign in with two-factor authentication`
  },
  {
    value: TWO_FACTOR_OPTIONS.Mandatory.value,
    description: defineMessage`Make two-factor authentication mandatory for users to sign in to Kissflow`
  },
  {
    value: TWO_FACTOR_OPTIONS.Disable.value,
    description: defineMessage`Do not provide an option for secure sign-in using two-factor authentication`
  }
];

export const USER_STATUS = {
  ACTIVE: "Active",
  INACTIVE: "InActive",
  REQUESTED_ACCESS: "Requested Access",
  INVITED: "Invited"
};

export const COLUMN_WIDTH = {
  ProfilePicture: 70,
  FirstName: 200,
  LastName: 200,
  NickName: 200,
  Email: 250,
  Groups: 250,
  Manager: 200,
  Status: 200,
  _created_by: 200,
  _created_at: 200,
  TFAEnrollment: 350,
  ExternalId: 250,
  LastLoggedInAt: 200,
  FlowName: 250,
  IsDisabled: 250,
  Label: 300,
  Approvers: 640,
  GroupCount: 200,
  UserCount: 215,
  Actions: 400,
  Name: 600,
  _programmatic_access: 200,
  _last_access: 200
};

export const PAGINATION_PAGES_LIST = ["10", "25", "100", "250", "500"];

export const NAME_FIELDS = ["FirstName", "LastName", "NickName"];

export const TO_EXPORT = [
  {
    label: defineMessage`Filtered data`,
    id: "current"
  },
  {
    label: defineMessage`All data`,
    id: "all"
  }
];

export const EXPORT_TYPES = [
  { label: defineMessage`CSV`, id: "CSV" },
  { label: defineMessage`JSON`, id: "JSON" }
];

export const EXPORT_VIEW = {
  CurrentView: "CurrentView",
  FileType: "FileType"
};

export const EXPORT_EXTENSIONS = { CSV: "CSV", JSON: "JSON" };

export const EMPTY_FIELDS = [undefined, ""];

export const USER_PROFILE_TYPES = {
  USER: "user"
};

export const USER_PROFILE_TYPES_LABELS = {
  [USER_PROFILE_TYPES.USER]: defineMessage`user`
};
